<!--Copy right - © 2024 tecera gmbh-->
<script>
    export let device_search_input;
    export let placeholder = "Suche";
    export let classes = "mb-2";
    export let is_sorting = false;
    export let on_save;
    export let is_sorting_enabled = false;

    $: {
        if (is_sorting) {
            device_search_input = "";
        }
    }
</script>

<div class="input-group {classes}">
    <div
        class="input-group-prepend"
        style="margin-right:0px; {is_sorting
            ? 'opacity: 0.75;pointer-events:none;'
            : ''}"
    >
        <span class="input-group-text" style="background-color:#f1f1f1;border:none;">
            <i class="fa fa-search" style="color:black;"></i>
        </span>
    </div>

    <input
        bind:value={device_search_input}
        id="device_search_field"
        style="background-color:#f1f1f1;border: none; box-shadow: none;outline:none;flex: 1 1 auto;width:1%;{device_search_input ==
        ''
            ? 'border-top-right-radius: 0.2rem;border-bottom-right-radius: 0.2rem;'
            : ''} {is_sorting ? 'opacity: 0.75;pointer-events:none;' : ''}padding:0.375rem 0;"
        type="text"
        {placeholder}
        aria-label="Search"
        maxlength="50"
        autocomplete="off"
    />

    <div
        class="input-group-append"
        style="border-top-right-radius: 0.2rem;border-bottom-right-radius: 0.2rem;background:#fff;margin-left:0px;"
    >
        <button
            class="btn btn-outline-secondary delete-btn"
            style="border-color:transparent;"
            type="button"
            class:hidden={device_search_input == ""}
            on:click={() => (device_search_input = "")}
        >
            <i class="fa fa-times" style="color:black;"></i>
        </button>
    </div>
{#if is_sorting_enabled}
    {#if is_sorting}
        <button
            class="btn btn-primary ml-2"
            on:click={() => {
                is_sorting = !is_sorting;on_save()
            }}
        >
            <i class="fa-solid fa-floppy-disk white"></i> Speichern
        </button>
    {:else}
        <button
            class="btn btn-primary ml-2"
            on:click={() => {
                is_sorting = !is_sorting;
            }}
        >
            <i class="fa-solid fa-sort white"></i>
        </button>
    {/if}
{/if}
</div>
